import React from 'react'

const BreastPumpDarkMode: React.FC<React.HTMLAttributes<SVGElement>> = () => (
  <svg
    fill="none"
    height="64"
    viewBox="0 0 64 64"
    width="64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50.9413 58.6C50.7913 58.6 50.6413 58.57 50.4913 58.49C46.9013 56.68 44.0813 53.88 42.5513 50.61C40.8313 46.93 40.8313 42.73 42.5413 39.37C43.4113 37.66 44.6813 36.24 45.9013 34.86C47.1313 33.48 48.3013 32.17 49.0513 30.62C50.4913 27.66 50.1313 23.9 48.1613 21.26C46.2013 18.62 42.6913 17.2 39.4413 17.73C38.9013 17.82 38.3813 17.45 38.2913 16.9C38.2013 16.35 38.5713 15.84 39.1213 15.75C43.0913 15.11 47.3613 16.84 49.7613 20.06C52.1613 23.28 52.5913 27.88 50.8413 31.49C49.9713 33.29 48.6513 34.76 47.3813 36.19C46.1913 37.53 45.0613 38.79 44.3013 40.27C42.8913 43.04 42.9113 46.67 44.3513 49.75C45.6913 52.61 48.1813 55.08 51.3813 56.68C51.8713 56.93 52.0713 57.53 51.8213 58.02C51.6413 58.37 51.2913 58.57 50.9313 58.57V58.6H50.9413Z"
      fill="#FED7FF"
    />
    <path
      d="M36.9916 33.3903V50.5903C35.6616 51.1003 34.7816 51.8003 32.3216 51.8003C28.4916 51.8003 28.4916 50.0903 24.6516 50.0903C22.1916 50.0903 21.3116 50.7903 19.9716 51.3003V33.4003C19.9716 30.8603 22.0316 28.7903 24.5816 28.7903H32.3816C34.9216 28.7903 36.9816 30.8503 36.9816 33.4003H36.9916V33.3903Z"
      fill="url(#paint0_linear_410_1757)"
    />
    <path
      d="M32.4316 20.7303C33.2516 20.7303 33.9216 20.0603 33.9216 19.2403V15.6103C33.9216 14.7903 33.2516 14.1203 32.4316 14.1203H24.4816C23.6616 14.1203 22.9916 14.7903 22.9916 15.6103V19.2403C22.9916 20.0603 23.6616 20.7303 24.4816 20.7303H25.1516V23.7803C23.9416 23.8803 22.9916 24.8903 22.9916 26.1203V26.4103C22.9916 27.7103 24.0516 28.7703 25.3516 28.7703H31.5616C32.8616 28.7703 33.9216 27.7103 33.9216 26.4103V26.1203C33.9216 24.8803 32.9716 23.8803 31.7616 23.7803V20.7303H32.4316Z"
      fill="url(#paint1_linear_410_1757)"
    />
    <path
      d="M33.6816 12.9003V20.8503C33.6816 21.6703 34.3516 22.3403 35.1716 22.3403H38.8016C39.6216 22.3403 40.2916 21.6703 40.2916 20.8503V12.9003C40.2916 12.0803 39.6216 11.4103 38.8016 11.4103H35.1716C34.3516 11.4103 33.6816 12.0803 33.6816 12.9003Z"
      fill="url(#paint2_linear_410_1757)"
    />
    <path
      d="M24.2816 16.7203C23.5616 22.4403 19.8416 26.7003 15.9516 26.2903C17.6416 26.2903 19.5416 21.8503 20.2516 16.2103C20.9516 10.6203 20.2416 5.9103 18.6416 5.3903C22.4816 6.0003 24.9916 11.0203 24.2716 16.7103H24.2816V16.7203Z"
      fill="url(#paint3_linear_410_1757)"
    />
    <path
      d="M19.5916 16.1103C18.8816 21.7503 16.9716 26.1803 15.2916 26.1903C15.2516 26.1903 15.2116 26.1903 15.1716 26.1803C13.4616 25.9703 12.6516 21.1103 13.3816 15.3303C14.1116 9.5503 16.1016 5.0303 17.8116 5.2603C17.8716 5.2603 17.9316 5.2803 17.9816 5.3003C19.5716 5.8103 20.2916 10.5303 19.5916 16.1203V16.1103Z"
      fill="url(#paint4_linear_410_1757)"
    />
    <path
      d="M36.9516 53.7903C36.9516 56.3303 34.8916 58.3903 32.3516 58.3903H24.5516C22.0116 58.3903 19.9416 56.3303 19.9416 53.7903V51.0303C21.2816 50.5203 22.1616 49.8203 24.6216 49.8203C28.4616 49.8203 28.4616 51.5303 32.2916 51.5303C34.7516 51.5303 35.6316 50.8303 36.9616 50.3203H36.9516V53.7903Z"
      fill="url(#paint5_linear_410_1757)"
    />
    <path
      d="M34.1216 37.0103H29.0716C28.5216 37.0103 28.0716 36.5603 28.0716 36.0103C28.0716 35.4603 28.5216 35.0103 29.0716 35.0103H34.1216C34.6716 35.0103 35.1216 35.4603 35.1216 36.0103C35.1216 36.5603 34.6716 37.0103 34.1216 37.0103Z"
      fill="#121112"
    />
    <path
      d="M34.1216 42.1903H29.0716C28.5216 42.1903 28.0716 41.7403 28.0716 41.1903C28.0716 40.6403 28.5216 40.1903 29.0716 40.1903H34.1216C34.6716 40.1903 35.1216 40.6403 35.1216 41.1903C35.1216 41.7403 34.6716 42.1903 34.1216 42.1903Z"
      fill="#121112"
    />
    <path
      d="M34.1216 47.3603H29.0716C28.5216 47.3603 28.0716 46.9103 28.0716 46.3603C28.0716 45.8103 28.5216 45.3603 29.0716 45.3603H34.1216C34.6716 45.3603 35.1216 45.8103 35.1216 46.3603C35.1216 46.9103 34.6716 47.3603 34.1216 47.3603Z"
      fill="#121112"
    />
    <path
      d="M38.7616 10.1503H35.1316C33.7616 10.1503 32.6416 11.2703 32.6416 12.6403V12.8903C32.5616 12.8903 32.4816 12.8703 32.4016 12.8703H24.6216C24.1616 8.3003 21.7116 4.7203 18.2516 4.0903C18.1516 4.0603 18.0516 4.0403 17.9016 4.0203C17.5116 3.9803 16.8916 4.0203 16.2216 4.5403C14.5016 5.8603 12.9816 9.9503 12.3516 14.9503C11.7216 19.9503 12.1716 24.2803 13.5016 26.0003C14.0316 26.6703 14.6116 26.8703 15.0016 26.9203H15.1416V26.9403C15.3516 26.9603 15.5616 26.9703 15.7716 26.9703H15.7816C18.8216 26.9703 21.6116 24.6803 23.2416 21.1703C23.5016 21.3203 23.8016 21.4203 24.1116 21.4603V22.7503C22.8316 23.2303 21.9516 24.4503 21.9516 25.8803V26.1703C21.9516 26.8203 22.1416 27.4303 22.4616 27.9403C20.4016 28.7703 18.9416 30.7903 18.9416 33.1503V50.3403H18.9216V53.8003C18.9216 56.8903 21.4416 59.4003 24.5316 59.4003H32.3416C35.4316 59.3903 37.9416 56.8803 37.9416 53.7903V51.0403H37.9616V33.1503C37.9616 30.7803 36.4816 28.7403 34.3916 27.9203C34.7016 27.4103 34.8916 26.8103 34.8916 26.1703V25.8803C34.8916 24.4503 34.0116 23.2303 32.7316 22.7503V21.4603C32.7316 21.4603 32.7716 21.4503 32.8016 21.4403C33.1516 22.4003 34.0616 23.0903 35.1316 23.0903H38.7616C40.1316 23.0903 41.2516 21.9703 41.2516 20.6003V12.6403C41.2516 11.2703 40.1316 10.1503 38.7616 10.1503ZM15.2516 24.9403C14.6716 24.6603 13.5716 21.3503 14.3416 15.2103C15.1316 8.9703 17.0616 6.0603 17.6416 6.0003H17.6516C17.7616 6.0503 17.8916 6.2003 18.0216 6.4603C18.5816 7.5903 19.1916 10.7103 18.5616 15.7303C17.7616 21.9603 15.8516 24.8703 15.2516 24.9403ZM22.5816 16.2403C22.4616 17.2003 22.2416 18.1203 21.9516 18.9803C21.1816 21.2803 19.8816 23.1303 18.3516 24.1303C19.0716 22.6803 19.6216 20.8403 20.0016 19.0803C20.2416 17.9803 20.4216 16.9003 20.5416 15.9803C20.7316 14.4503 20.8616 12.4703 20.7916 10.5703C20.7516 9.5203 20.6516 8.4903 20.4616 7.5703C21.7116 8.9603 22.5216 11.1403 22.6716 13.6203C22.7216 14.4703 22.7016 15.3503 22.5816 16.2403ZM35.9516 53.8003C35.9516 55.7803 34.3416 57.4003 32.3516 57.4003H24.5416C22.5516 57.4003 20.9316 55.7903 20.9316 53.8003V51.7103C20.9816 51.6903 21.0316 51.6603 21.0816 51.6403C21.1116 51.6303 21.1516 51.6103 21.1816 51.6003L21.2216 51.5803C22.1316 51.1803 22.9216 50.8303 24.6116 50.8303C26.3016 50.8303 27.1116 51.1903 28.0316 51.5903H28.0416C29.0316 52.0303 30.1516 52.5303 32.2716 52.5303C34.0016 52.5403 35.0616 52.2103 35.9316 51.8603V53.7903L35.9516 53.8003ZM35.9516 33.1303V49.6603C35.8716 49.7003 35.7816 49.7303 35.7016 49.7703H35.6716L35.6716 49.7803C34.7616 50.1803 33.9716 50.5303 32.3216 50.5403H32.2816C30.5916 50.5403 29.7916 50.1803 28.8716 49.7803H28.8616C27.8716 49.3303 26.7416 48.8303 24.6116 48.8303V48.8103C22.8716 48.8103 21.8016 49.1503 20.9316 49.5103V33.1303C20.9316 31.1403 22.5516 29.5203 24.5416 29.5203H25.0516C25.1416 29.5203 25.2216 29.5303 25.3116 29.5303H31.5316C31.6216 29.5303 31.7016 29.5303 31.7916 29.5203H32.3516C34.3316 29.5203 35.9516 31.1403 35.9516 33.1303ZM32.8516 18.9903C32.8516 19.1503 32.7616 19.2903 32.6416 19.3803C32.5616 19.4403 32.4716 19.4803 32.3616 19.4803H30.6916V24.4503L31.6116 24.5303C32.3216 24.6003 32.8616 25.1703 32.8616 25.8803V26.1703C32.8616 26.9203 32.2516 27.5303 31.5016 27.5303H25.2916C24.5416 27.5303 23.9316 26.9203 23.9316 26.1703V25.8803C23.9316 25.1703 24.4716 24.5903 25.1816 24.5303L26.1016 24.4503V19.4803H24.4316C24.2316 19.4803 24.0716 19.3603 23.9916 19.2003L24.6916 14.8703H32.3616C32.4716 14.8703 32.5616 14.9103 32.6416 14.9703C32.7616 15.0603 32.8516 15.2003 32.8516 15.3603V18.9903ZM39.2516 20.6203C39.2516 20.8903 39.0316 21.1103 38.7616 21.1103H35.1316C34.8616 21.1103 34.6416 20.8903 34.6416 20.6203V12.6603C34.6416 12.3903 34.8616 12.1703 35.1316 12.1703H38.7616C39.0316 12.1703 39.2516 12.3903 39.2516 12.6603V20.6203Z"
      fill="#121112"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_410_1757"
        x1="17.0771"
        x2="43.9269"
        y1="54.9468"
        y2="25.3832"
      >
        <stop stopColor="#64AF68" />
        <stop offset="1" stopColor="#A4D4FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_410_1757"
        x1="30.3055"
        x2="14.1114"
        y1="12.8563"
        y2="51.4269"
      >
        <stop stopColor="#F4D04E" />
        <stop offset="1" stopColor="#E96C4C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_410_1757"
        x1="32.8638"
        x2="16.7234"
        y1="9.98884"
        y2="52.8572"
      >
        <stop stopColor="#F4D04E" />
        <stop offset="1" stopColor="#E96C4C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_410_1757"
        x1="12.1054"
        x2="41.3099"
        y1="31.6949"
        y2="31.6949"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F6D2FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_410_1757"
        x1="12.0654"
        x2="41.2616"
        y1="31.676"
        y2="31.676"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F6D2FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_410_1757"
        x1="20.3347"
        x2="57.9404"
        y1="-17.1266"
        y2="-0.520124"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F6D2FB" />
      </linearGradient>
    </defs>
  </svg>
)

export default BreastPumpDarkMode
